import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/holidays`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    console.log(id);
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/holidays/${id}`, options)
        .then(response => {
            let holiday = jsona.deserialize(response.data);
            delete holiday.links;
            console.log(holiday);
            return holiday;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/holidays/${id}`, options)
        .then(response => {
            let holiday = jsona.deserialize(response.data);
            delete holiday.links;
            return holiday;
        });
}

function add (holiday) {
    const payload = jsona.serialize({
        stuff: holiday,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/holidays`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (holiday) {
    const payload = jsona.serialize({
        stuff: holiday,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/holidays/${holiday.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/holidays/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

